module.exports = __webpack_public_path__ + "static/media/41.7d5cfa0d.jpg";